import React from 'react'
import { Form } from 'react-bootstrap'
import DimensionsSelector from '../../dimensions/selector'

const DimensionParam = ({
    label,
    value,
    onChange = () => {},
}) => {
    return (
        <Form.Group>
            <Form.Label>{label || 'Dimension'}</Form.Label>
            <DimensionsSelector
                value={value}
                onChange={onChange}
            />
        </Form.Group>
    )
}

export default DimensionParam